import React from "react";

interface Props {
  children: any
}

export default (props: Props) =>
  // <pre>{JSON.stringify(props.children, null, 2)}</pre>
  null
